import { ticketType } from "@agentcall/core/type"
import * as React from "react"
import type { TicketStatus } from "@/components/tickets/type"
import { cn } from "@/lib/utils"

export type TicketTabStatus = TicketStatus | "all"

interface TicketStatusTabsProps {
  activeTab: TicketTabStatus
  onTabChange: (tab: TicketTabStatus) => void
  className?: string
}

const tabs: { value: TicketTabStatus; label: string }[] = [
  { value: "all", label: "全て" },
  { value: ticketType.TICKET_STATUS_OC_IN_PROGRESS, label: "OC\n対応中" },
  { value: ticketType.TICKET_STATUS_OWNER_IN_PROGRESS, label: "オーナー\n対応中" },
  { value: ticketType.TICKET_STATUS_CONTRACTOR_IN_PROGRESS, label: "業者\n対応中" },
  { value: ticketType.TICKET_STATUS_COMPLETED, label: "完了" },
]

export const TicketStatusTabs = React.forwardRef<HTMLDivElement, TicketStatusTabsProps>(
  ({ activeTab, onTabChange, className }, ref) => {
    return (
      <div ref={ref} className={cn("bg-slate-100 rounded-md p-1", className)}>
        <div className="flex gap-0.5">
          {tabs.map((tab) => (
            <button
              key={tab.value}
              type="button"
              onClick={() => onTabChange(tab.value)}
              className={cn(
                "flex-1 py-1.5 rounded text-xs font-semibold text-center whitespace-pre-line leading-4 transition-all",
                activeTab === tab.value
                  ? "bg-white text-[#354267] shadow-sm"
                  : "text-slate-500 hover:text-slate-600"
              )}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>
    )
  }
)

TicketStatusTabs.displayName = "TicketStatusTabs"
